import { React, useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Slider from "react-slick";

import { Button, LinkButton } from "../../commonComponents/Buttons";
import { useLockBodyScroll } from "../../../hooks";

import { LikedIcon, UnlikedIcon, DefaultCover, VideoViewsIcon } from "../../../assets";
import "./challengesViewModal.scss";

function ChallengesViewModal({
  setVisibleViewChallengesModal,
  setVisibleRemoveSingleChallengesModal,
  type,
  userAnswers,
  likeHandler,
  setCheckedItems,
  categoryId,
  challengeId,
  setViewsCounter,
  closeViewModal,
  setExpandUserId,
  expandUserId,
}) {
  useLockBodyScroll();
  const { t } = useTranslation();

  const [viewsCounterIndex, setViewsCounterIndex] = useState(0);

  useEffect(() => {
    if (!expandUserId) {
      setExpandUserId(userAnswers[0]?.user?.id);
    }
  }, [expandUserId, userAnswers, setExpandUserId]);

  function renderLeftArrows() {
    return (
      <div className="slider-arrow left">
        <Button
          iconClassName="hasIcon--chevron-left"
          customClassName="slide-arrow-custom arrow-btn prev"
          onClick={() => sliderRef.current.slickPrev()}
        />
      </div>
    );
  }

  function renderRightArrows() {
    return (
      <div className="slider-arrow rigth">
        <Button
          iconClassName="hasIcon--chevron-right"
          customClassName="slide-arrow-custom arrow-btn next"
          onClick={() => sliderRef.current.slickNext()}
        />
      </div>
    );
  }

  useEffect(() => {
    if (userAnswers.length === 0) {
      setVisibleViewChallengesModal(false);
    }
  }, [userAnswers, setVisibleViewChallengesModal]);

  useEffect(() => {
    setViewsCounter((currentState) => [
      ...currentState,
      userAnswers[viewsCounterIndex]?.id,
    ]);
  }, [viewsCounterIndex, userAnswers, setViewsCounter]);

  const sliderRef = useRef();

  const settings = {
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    afterChange: (current) => setViewsCounterIndex(current),
  };

  return (
    <>
      <section className="modalBg">
        <section className="viewModal modalBody">
          <div className="carouselContainer">
            {userAnswers.length > 1 && renderLeftArrows()}
            {userAnswers.length > 1 && renderRightArrows()}
            <Slider {...settings} ref={sliderRef}>
              {userAnswers.map((item) => (
                <div key={item?.id}>
                  <div>
                    <h3 className="itemTittle">{item?.title}</h3>
                    {item?.status === "pending" && item?.user?.request_user && (
                      <p className="cardLabel pendingLabel">{t("pending")}</p>
                    )}
                  </div>
                  {item?.answer_type === "video" ? (
                      <div className="carouselImageBlock">
                          <img
                              className="carouselImage"
                              src={item?.cover_image || DefaultCover}
                              alt={item?.title}
                          />
                          <LinkButton
                              goTo={`/videView/${categoryId}/${challengeId}/${item?.user?.id}`}
                              iconClassName="hasIcon--play"
                              customClassName="playImage"
                          />
                      </div>
                  ) : item?.answer_type === "pdf" ? (
                      <div className="carouselImageBlock">
                          <a href={item?.content} target="_blank" rel="noopener noreferrer">
                              <img
                                  className="carouselImage"
                                  src={item?.cover_image}
                                  alt={item?.title}
                              />
                          </a>
                      </div>
                  ) : item?.answer_type === "image" ? (
                      <div className="carouselImageBlock">
                          <img
                              className="carouselImage"
                              src={item?.content}
                              alt={item?.title}
                          />
                      </div>
                  ) : (
                      <div className="carouselTextBlock">
                          {item?.content?.split('\n').map((paragraph, index) => (
                              <p key={index} className="carouselText">{paragraph}</p>
                          ))}
                      </div>
                  )}

                  <div className="info-block">
                    <p className="ownerTitle">
                      {" "}
                      {item?.user?.name}
                      {item?.user?.age && `, ${item?.user?.age} years`}
                    </p>
                    <div className="activityCounter">
                      <div className="leftBlock">
                        <div className="viewsCounter">
                          <img
                            className="activityIcon"
                            src={VideoViewsIcon}
                            alt={t("views")}
                          />
                          <p className="activityTxt">{item?.views}</p>
                        </div>
                        <div>
                          <Button
                            viewType="clildrenBtn"
                            onClick={() => likeHandler(item?.id)}
                          >
                            <img
                              className="activityIcon"
                              src={item?.liked ? LikedIcon : UnlikedIcon}
                              alt={t("likes")}
                            />
                          </Button>
                          <p className="activityTxt">{item?.likes}</p>
                        </div>
                      </div>

                      {item?.user?.request_user && (
                        <Button
                          customClassName="trashBtn"
                          viewType="transparentIcon"
                          iconClassName="hasIcon--trash-2"
                          onClick={() => {
                            setVisibleRemoveSingleChallengesModal(true);
                            setCheckedItems([`${item?.id}`]);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <Button
            iconClassName="hasIcon--close"
            viewType="transparentIcon"
            onClick={() => closeViewModal()}
          />
        </section>
      </section>
    </>
  );
}

export default ChallengesViewModal;
